'use strict';/* global define */define('modules/feedback/services/feedback-settings/index',['require','exports','module'],function(require,exports,module){'use strict';// @ngInject
factory.$inject = ["$resource", "API_ENDPOINT"];
function factory($resource,API_ENDPOINT){// jshint validthis:true
// jshint latedef:false
var resource=$resource(API_ENDPOINT+'feedback-settings/:id',{id:'@id'},{patch:{method:'PATCH'}});return{save:resource.save,patch:resource.patch};}module.exports=factory;});
